import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { cva } from 'class-variance-authority';
import { type Asset, type KeyValueFieldObject } from 'korint-sdk';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const tierBadgeVariants = cva('px-2 py-1 rounded-md font-semibold text-center', {
  variants: {
    tier: {
      BASIC: 'bg-blue-100 text-blue-700',
      STANDARD: 'bg-violet-100 text-violet-700',
      PREMIUM: 'bg-yellow-100 text-yellow-700',
      ESSENTIEL: 'bg-blue-100 text-blue-700',
      SUMMUM: 'bg-yellow-100 text-yellow-700',
    },
  },
});

const definedTiers = ['BASIC', 'STANDARD', 'PREMIUM', 'ESSENTIEL', 'SUMMUM'] as const;

export const QuoteTableChosenTier = ({
  asset,
  fallbackTier,
}: {
  asset?: Asset<KeyValueFieldObject>;
  fallbackTier?: string;
}) => {
  const { t } = useTranslation();

  const { policy } = usePolicyOnDashboard();

  const chosenTier = useMemo(
    () => asset?.quote?.options.tier ?? fallbackTier,
    [asset, fallbackTier],
  );

  const isTierDefined =
    chosenTier && definedTiers.includes(chosenTier as (typeof definedTiers)[number]);

  return (
    <tr>
      <td className="font-semibold text-sm hidden md:table-cell">
        {t('quoteTierModule.chosenTier')}
      </td>
      <td className="uppercase" colSpan={2}>
        {chosenTier && (
          <div
            className={
              isTierDefined
                ? tierBadgeVariants({
                    tier: chosenTier as never,
                  })
                : tierBadgeVariants({
                    tier: 'BASIC',
                  })
            }
          >
            {t([`${policy?.productId}.tiers.${chosenTier}.label`, `tiers.${chosenTier}.label`])}
          </div>
        )}
      </td>
    </tr>
  );
};
